import axios from "axios";
import {Message} from 'element-ui';
import StorageUtils from "@/utils/storageUtils";
import ToRoute from "@/utils/ToRoute";
import router from '@/router';

class Http {
    constructor(config) {
        this.instance = axios.create(config);

        // 请求拦截器
        this.instance.interceptors.request.use(
            (config) => {
                // 自动携带 token
                const token = StorageUtils.getItem('token');
                if (token) {
                    config.headers.Token = token;
                }
                // 可以在这里加入 loading 动画等操作
                return config;
            },
            (err) => {
                return Promise.reject(err);
            }
        );

        // 如果外部传入了拦截器，合并进去（如自定义请求头）
        if (config.interceptors?.requestInterceptor) {
            this.instance.interceptors.request.use(
                config.interceptors.requestInterceptor,
                config.interceptors.requestInterceptorCatch
            );
        }

        // 响应拦截器
        this.instance.interceptors.response.use(
            (response) => {
                const res = response.data;
                // 登录失效
                if (res.code == 300) {
                    Message.error(res.message);
                    StorageUtils.clear();
                    ToRoute.toRoute(router, 'login', {},1000)
                    return Promise.reject(new Error(res.message));
                }

                // 业务错误处理（根据后端返回格式）
                if (res.error === true) {
                    const errorMessage = res.message || '网络异常';
                    // 使用 Element UI 提示错误
                    // Message.error(errorMessage);
                    return Promise.reject(new Error(errorMessage));
                }
                return res; // 正常数据直接返回
            },
            (error) => {
                // 网络错误或超时统一处理
                const message = error.message.includes('timeout')
                    ? '请求超时，请检查网络'
                    : '服务器开小差啦～';

                Message.error(message);

                return Promise.reject(error);
            }
        );
    }

    request(config) {
        return new Promise((resolve, reject) => {
            this.instance
                .request(config)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    get(config) {
        return this.request({...config, method: 'get'});
    }

    post(config) {
        return this.request({...config, method: 'post'});
    }
}

export default Http;
